import { Checkbox } from "antd";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import { useSticky } from "react-table-sticky";
import { common_axios } from "../../../../App";
import { toast, ToastContainer } from "react-toastify";
import CheckBox from "./ReactTableFiles/CheckBox";
// import ColumnFilter from "../../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import ColumnFilter from "./ReactTableFiles/ColumnFilter";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableViewIcon from "@mui/icons-material/TableView";
import PersonIcon from "@mui/icons-material/Person";
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import RefreshIcon from "@mui/icons-material/Refresh";
import InfoIcon from "@mui/icons-material/Info";
import { useParams } from "react-router-dom";
import {
  Backdrop,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextareaAutosize,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import Loader from "../../../../components/Loader";
import { SettingsInputComponent } from "@mui/icons-material";
import * as React from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import SearchIcon from "@mui/icons-material/Search";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
export default function Rechargemanagement() {
  const { id } = useParams();

  const [open, setOpen] = useState();
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [fetchData, setFetchData] = useState([]);
  const[hideSkeleton,setHideSkeleton]= useState()
  const [Status, setStatus] = useState({
    approveType: 0,
    resellerName: null,
    type: null,
    approveAssignedType: null,
    hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const[uid,setUid]=useState([ {
    uid: "all",
    username: "All",
  },])

  const customId1 = "custom-id-yes";
// ...................................................................................................//

async function BulkTableget() {
 setData([])
 try {
  setOpen(true);
   const result = await common_axios.post(
     `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/recharge/v1/get/details`,
     {
       rechargeRequest:{
         pageNo: Status?.pageNo,
         pageSize: Status?.pageSize,
           // userId:uid.uid
          //  userId:userIds.includes("all") ? null : userIds,
          userId:[parseInt(id)],
       }
   }

   );
   if (result.data.statusDescription.statusCode == 200) {
     await setData(result.data.rechargeDeatils.content);
     await setData1(result.data.rechargeDeatils);
     setOpen(false);
   } else {
     setOpen(false);
     Swal.fire({
       icon: "error",
       title: "Oops...",
       text: result.data.statusDescription.statusMessage,
       // footer: '<a href="">Why do I have this issue?</a>'
     });
   }
 } catch (error) {
   setOpen(false);
   Swal.fire({
     icon: "error",
     title: "Oops...",
     text: "Please Check Your Network",
     // footer: '<a href="">Why do I have this issue?</a>'
   });
 }
}
// ........................................RefreshBtn API.................................................//
async function RefreshBtn() {
 setData([])
 try {
  setOpen(true);
   const result = await common_axios.post(
     `${process.env.REACT_APP_COMMON_API_DASHBOARD_API}/sms/recharge/v1/get/details`,
     {
       rechargeRequest:{
         pageNo: Status?.pageNo,
         pageSize: Status?.pageSize,
          userId:[parseInt(id)],
       }
   }
   );
   if (result.data.statusDescription.statusCode == 200) {
     await setData(result.data.rechargeDeatils.content);
     await setData1(result.data.rechargeDeatils);
     setOpen(false);
   } else {
     setOpen(false);
     Swal.fire({
       icon: "error",
       title: "Oops...",
       text: result.data.statusDescription.statusMessage,
     });
   }
 } catch (error) {
   setOpen(false);
   Swal.fire({
     icon: "error",
     title: "Oops...",
     text: "Please Check Your Network",
     // footer: '<a href="">Why do I have this issue?</a>'
   });
 }
}
  useEffect(async () => {
    if(id!=undefined){
      BulkTableget()
  
    }
  }, [Status.pageSize,Status.pageNo,id]);
  // useEffect(()=>{
  //   if(id!=undefined){
  //     BulkTableget()
  
  //   }
  // },[id])

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Id",
        Footer: "ID",
        accessor: "id",
        Cell: (cell) =>  <>{cell.row.index + 1 + Status?.pageNo * Status?.pageSize}</>
      },
      {
        Header: "recharge By",

        accessor: "username",
      },
      {
        Header: "Username",

        accessor: "rechargeUsername",
      },
      {
        Header: "Recharge Date",

        accessor: "rechargeDate", 
        
      },
      {
        Header: "Amount",

        accessor: "amount",
      },
      {
        Header: "Status",

        accessor: "status",
        Cell: (cell) => {
          return (
            <>
              {cell.row.original.status == 0 ? (
                <div className="badge badge_8 bg-warning">Pending</div>
              ) : cell.row.original.status == 1 ? (
                <div className="badge badge_8 bg-success">Success</div>
              ) : (
                <div className="badge badge_8 bg-danger">Failed</div>
              )}
            </>
          );
        },
      },
    ],
    [Status]
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    // footerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      // initialState: { pageIndex: 1 }
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const viewRefModal = useRef(null);

  const { globalFilter, pageIndex, pageSize } = state;

  const deletUser = () => {
  };

  return (
    <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
      <div className="container-fluid">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>
        <div className="card mb-3 mt-5">
          <div className="card-header p-3 pt-2">
            <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
            <PersonIcon
                    style={{
                      color: "white",
                      fontSize: "27px",
                    }}
                  />        
                  
                      </div>
            <div style={{ marginLeft: "6rem" }}>
              <p className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline">
                View Credit
              </p>
            </div>
          </div>

          <div className="card-body row">
            {data?.length > 0 ? (
              <>
                  <>
                    <div className="d-flex justify-content-between mt-4">
                        <select
                          value={Status.pageSize}
                          className="dropdown"
                          onChange={(e) => {
                            setPageSize(Number(e.target.value));
                            setStatus({
                              ...Status,
                              pageSize: e.target.value,
                            });
                          }}
                        >
                          {[10, 25, 50].map((value, i) => {
                            return (
                              <option
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton1"
                                value={value}
                                key={value}
                              >
                                Show {value}
                              </option>
                            );
                          })}
                        </select>
                        
                        {/* <Tooltip title="Refresh">
                  <button
                    type="submit"
                    className="btn bg-gradient-primary w_btn m-0 ms-3 me-3 search_1  "
                    onClick={() => RefreshBtn("Text to Copy")}
                  >
                    <RefreshIcon />
                  </button>
                </Tooltip> */}

                      {/* <TextField
                        className="ms-4"
                        style={{
                          borderRadius: "4px",
                        }}
                        type="text"
                        label="Search"
                        name="Search"
                        variant="outlined"
                        // value={number}
                        size="small"
                        value={globalSearchValue || ""}
                        onChange={(e) => {
                          onChange(e.target.value);
                          setGlobalSearchValue(e.target.value);
                        }}
                      /> */}
                    </div>
                  </>

                <div className="text-end">
                  {selectedFlatRows.length > 0 && (
                    <button
                      onClick={deletUser}
                      className="btn bg-gradient-primary m-0"
                    >
                      Delete Users
                    </button>
                  )}
                </div>

                <div className="table-responsive">
                  <table
                    {...getTableProps()}
                    id="example"
                    className="table table-striped table-bordered dataTable table-sm mt-3"
                    style={{ width: "100%" }}
                  >
                    <thead>
                      {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map((column) => (
                            <th
                              {...column.getHeaderProps(
                                column.getSortByToggleProps()
                              )}
                              className="text-center width_2"
                            >
                              {column.render("Header")}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? "↑"
                                    : "↓"
                                  : ""}
                              </span>
                            </th>
                          ))}
                        </tr>
                      ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                      {page.map((row) => {
                        prepareRow(row);
                        return (
                          <tr {...row.getRowProps()}>
                            {row.cells.map((cell) => {
                              return (
                                <td
                                  {...cell.getCellProps()}
                                  // className="text-left"
                                //   className={
                                //   (cell.column.Header == "User Id" ||
                                //     cell.column.Header == "Amount" ||
                                //     cell.column.Header == "Start Date") &&
                                //   "text-end"
                                // }

                                
                                className={
                                  cell.column.Header == "Id" ||
                                    cell.column.Header == "Amount"
                                                            ? "text-end"
                                                            : cell.column
                                                                .Header ==
                                                                "Status"
                                                            ? "text-center"
                                                            : "text-start"
                                                        }
                                >
                                  {cell.render("Cell")}
                                </td>
                              );
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <div>
                    <span>
                      Page:
                      <strong>
                        {data1?.pageable?.pageNumber + 1} of {data1?.totalPages}
                      </strong>
                    </span>
                  </div>

                  {/* <div>
                    <span>
                      Go to Page :
                      <input
                        type="number"
                        // defaultValue={pageIndex + 1}
                        // value={data1?.pageable?.pageNumber + 1}
                        value={Status?.pageNo + 1}
                        onChange={(e) => {
                          if (
                            e.target.value > 0 &&
                            e.target.value < data1?.totalPages + 1
                          ) {
                            const pageNumber = e.target.value
                              ? Number(e.target.value) - 1
                              : 0;
                            setStatus({
                              ...Status,
                              pageNo: pageNumber,
                            });
                          }
                        }}
                        style={{ width: "50px" }}
                      />
                    </span>
                  </div> */}

                  <div>
                    <button
                      className="btn btn_primary "
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={data1?.pageable?.pageNumber == 0}
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo - 1,
                        });
                      }}
                    >
                      Prev
                    </button>

                    <button
                      className="btn btn_primary ms-2"
                      type="button"
                      style={{ background: "#2C97D4" }}
                      disabled={
                        data1?.totalPages == data1?.pageable?.pageNumber + 1
                      }
                      onClick={() => {
                        setStatus({
                          ...Status,
                          pageNo: Status.pageNo + 1,
                        });
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </>
            ) : (
              <div className="text-center mt-4">
              {data?.length == 0 && open == true ? null : data?.length == 0 &&
                open == undefined ? null : (
                <div className="text-center">
                  <h5>Data Not Found</h5>
                </div>
              )}
            </div>
           
            )}
          </div>
        </div>
      </div>
    </main>
  );
}
